<template>
  <header @mouseleave="isShow = false" class="header">
    <div class="header-content">
      <div style="display: flex">
        <h1 class="content-logo">
          <img src="@/assets/imgs/logo.png" />
        </h1>
        <div class="content-nav">
          <ul>
            <li>
              <!-- <span >首 页</span> -->
              <span @click="goTurn('/home')">首 页</span>
            </li>
            <!-- <li>
              <span @click="goTurn('/course/list')">课 程</span>
            </li> -->
            <li><span @click="goTurn('/questionBank/questionBankList')" >题库</span></li>
            <li><span @click="goZixun">资讯</span></li>
            <!-- <li><span>关于考蝈</span>
              </li> 
                 <li><span>下载客户端</span>
              </li>  -->
          </ul>
          <!-- 课程中心    题库       资讯       关于考蝈      下载客户端 -->
        </div>
      </div>

      <div class="search-buy-login">
        <div class="cntent-shopping">
          <el-icon :size="24" color="#808080"><shopping-cart /></el-icon>
        </div>
        <div class="content-login" v-if="!isLogin">
          <router-link to="/login">登录/注册</router-link>
        </div>
        <div class="content-login-success" v-else>
          <div style="cursor: pointer" @click="handlMyCourse">我的课程</div>
          <div @mouseenter="isShow = true">
            <img class="avator" :src="filterItem('avatar')" />
          </div>
        </div>

        <!-- 划过头像显示  -->
        <div class="user-account-menu" v-show="isShow">
          <div class="user-avatar">
            <img class="avatar-img" :src="filterItem('avatar')" alt="UserAvatar" />
            <div class="user-name">{{ filterItem("nick_name") }}</div>
          </div>

          <ul class="menu-items">
            <li @click="toTurn('/course/myCourses')">我的主页</li>
            <li v-if="userInfo&&userInfo.jl&&userInfo.jl==1" @click="toTurn('/student/myResume')">我的简历</li>
            <li class="logout" @click="loginOut">退出登录</li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <div style="height: 75px"></div> -->
  </header>
</template>


<script>
import { memberDetail } from "@/service/member.js";
export default {
  data() {
    return {
      isShow: false,
      token: null,
      userInfo: null,
    };
  },
  created() {
    this.token = localStorage.getItem("token");
    if (this.token) {
      this.getMemberDetail();
    }
  },
  computed: {
    isLogin() {
      return !!this.token;
    },
    filterItem() {
      return function (key) {
        if (this.userInfo) {
          return this.userInfo[key];
        } else {
          return null;
        }
      };
    },
  },
  methods: {
    handlMyCourse() {
      this.$router.push("/course/myCourses");
    },
    goZixun(){
      window.open('http://www.guoyinhang.com/', '_blank');
    },
    async getMemberDetail() {
      let res = await memberDetail();
      if (res.code == 0) {
        this.userInfo = res.data;
        localStorage.setItem("userInfo", res.data);
      }
    },
    loginOut() {
      localStorage.removeItem("token");
      this.$router.replace("/login");
    },
    toTurn(path) {
      this.$router.push(path);
    },
    goTurn(path) {
      if (path == this.$route.path) {
        return;
      }
      this.$router.replace(path);
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  // position: relative;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // width: 100%;
  // height: 75px;
  // background: #ffffff;

  position: fixed;
  display: block;
  width: 100%;
  height: 75px;
  min-width: 1280px;
  z-index: 101;
  box-shadow: 0 2px 10px #2f333814;
  background-color: #fff;
  top: 0;
}
.header-content {
  // position: fixed;
  // display: flex;
  // justify-content: space-around;
  //  max-width: 1200px;
  // width: 100%;
  // height: 75px;
  // background: #ffffff;
  // box-shadow: 0px 5px 6px rgba(0, 0, 0, 0.16);

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  grid-column-gap: 40px;
  -moz-column-gap: 40px;
  column-gap: 40px;
  width: 100%;
  max-width: 1200px;
  //
  margin: auto;
  padding: 0 50px;
}

.content-logo {
  width: 160px;
  height: 55px;
  margin: 10px 0;
  cursor: pointer;
}
.content-logo img {
  height: 100%;
  width: 100%;
}
.content-nav {
  width: 300px;
  height: 75px;
}
.content-nav ul {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 75px;
}
.content-nav ul li {
  font-size: 18px;
  color: #808080;
  cursor: pointer;
}
.content-nav ul li a {
  font-size: 18px;
  color: #808080;
  cursor: pointer;
  text-decoration: none;
}
.search-buy-login {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 650px;
  position: relative;
}

.content-login a {
  font-size: 18px;
  color: #808080;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
}
.content-login-success {
  height: 53px;
  color: #808080;
  text-align: center;
  width: 180px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #707070;
}
.avator {
  height: 53px;
  width: 53px;
  cursor: pointer;
  border-radius: 50%;
}
.user-info {
  height: 194px;
  background-color: #fff;
  border: 1px solid rgba(248, 250, 252, 1);
  box-shadow: 0px 5px 15px 3px #888888;
  position: absolute;
  top: 75px;
  right: -40px;
  z-index: 999;
  display: block;
  border-radius: 10px;
}
.user-info-top {
  display: flex;
  width: 100%;
  height: 160px;
  border-bottom: 1px solid rgba(248, 250, 252, 1);
  flex-direction: column;
}
.u-i-t-top {
  display: flex;
  height: 80px;
  width: 100%;
  align-items: center;
}
.u-i-t-top img {
  width: 40px;
  height: 40px;
  margin: 0 10px;
  cursor: pointer;
}
.avator-info {
  width: 120px;
  height: 60px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  display: flex;
  flex-direction: column;
  /*align-items: center;*/
}

.user-info > li {
  font-size: 16px;
  color: #666;
  padding: 10px 20px;
}

/* 整体菜单容器样式 */
.user-account-menu {
  background-color: #fff;
  border: 1px solid #f8fafc;
  box-shadow: 0px 5px 15px 3px #888888;
  position: absolute;
  top: 60px;
  right: 10px;
  z-index: 999;
  display: block;
  border-radius: 10px;
  padding: 20px;
  font-size: 16px;
}

/* 用户头像样式 */
.user-avatar {
  display: flex;
  align-items: center;
  .avatar-img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: lightblue;
    text-align: center;
    line-height: 50px;
    margin: 0 10px 10px 0;
  }
  .user-name {
    font-weight: bold;
    margin-bottom: 10px;
  }
}

/* 菜单项列表样式 */
.menu-items {
  list-style: none;
  padding: 0;
  .logout {
    border-top: 1px solid #ccc;
    margin-top: 10px;
    padding-top: 4px;
  }
}

/* 单个菜单项样式 */
.menu-items li {
  padding: 5px 0;
  cursor: pointer;
  line-height: 26px;
}

.menu-items li:hover {
  background-color: #f0f0f0;
}
</style>